import axios from 'axios';
import { API_URL } from '@/config/api';
import router from '@/router';

const TOKEN_KEY = 'auth_token';

const authApi = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

authApi.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      console.error('Erro na configuração da requisição de auth:', error);
      return Promise.reject(error);
    }
);

authApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        console.error('Erro na resposta de auth:', error.response.status, error.response.data);
      } else if (error.request) {
        console.error('Não recebeu resposta (possível CORS):', error.request);
      } else {
        console.error('Erro na configuração da requisição:', error.message);
      }
      return Promise.reject(error);
    }
);

const authService = {
  token: {
    set(token) {
      localStorage.setItem(TOKEN_KEY, token);
    },
    get() {
      return localStorage.getItem(TOKEN_KEY);
    },
    remove() {
      localStorage.removeItem(TOKEN_KEY);
    },
    decode() {
      try {
        const token = this.get();
        if (!token) return null;

        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(window.atob(base64));

        return payload;
      } catch (error) {
        console.error('Erro ao decodificar token:', error);
        return null;
      }
    },
    isExpired() {
      const payload = this.decode();
      if (!payload) return true;

      return payload.exp * 1000 < Date.now();
    }
  },

  async login(username, password) {
    try {
      const loginPath = '/auth/login';

      console.log(`Tentando login em: ${API_URL}${loginPath}`);

      const response = await authApi.post(loginPath, { username, password });

      console.log('Resposta de login:', response.data);

      if (response.data.token) {
        this.token.set(response.data.token);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Erro detalhado de login:', error);
      return false;
    }
  },

  logout() {
    this.token.remove();
    router.push('/login');
  },

  isAuthenticated() {
    const hasToken = !!this.token.get();
    if (hasToken && this.token.isExpired()) {
      console.log('Token expirado, fazendo logout');
      this.logout();
      return false;
    }
    return hasToken;
  },

  getAuthHeaders() {
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token.get()}`
    };
  },

  async ensureAuthentication() {
    if (!this.isAuthenticated()) {
      console.log('Usuário não autenticado, redirecionando para login');
      await router.push('/login');
      return false;
    }
    return true;
  }
};

export default authService;